import React, { useEffect } from "react";
import { useTable } from "react-table";
import EditableCell from "./EditableCell";
import DragAndDrop from '../../../libs/HOCS/DragAndDrop';
import update from "immutability-helper";
import Row from "./Row";

const defaultColumn = {
  Cell: EditableCell,
  width: 100
};

export default function Table({ columns, data, updateMyData , onRowUpdate}) {
  
  //const [records, setRecords] = React.useState(data);

  const getRowId = React.useCallback((row) => {
    return row.position;
  }, []);

  // useEffect(() =>{
  //   //setRecords(prevState => prevState);
  //   console.log(`use effect [records]`);
  //   console.log(records);
  //   updateMyData(records);
  // },[records,data]);

  // useEffect(() => {
  //   console.log(`use effect [data]`);
  //   setRecords(data);
  // },[data]);

  const updateCell = (index, id, value) => {
    //let data = [...records];
   // data[index][id] = value;
   const row = {...data[index]}
   row[id]=value;
    const updatedRow = row;
    onRowUpdate(updatedRow);
    //setRecords(data);
  }

  // Use the state and functions returned from useTable to build your UI
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow
  } = useTable({
    // data,
    data
    //: records
    ,
    columns,
    getRowId,
    defaultColumn,
    updateCell
  });

  const moveRow = (dragIndex, hoverIndex) => {
    //const dragRecord = records[dragIndex];
    //const hoverRecord = records[hoverIndex];
    const dragRecord = data[dragIndex];
    //const newArr =  
    const newData = update(data, {
      $splice: [
        [dragIndex, 1],
        [hoverIndex, 0, dragRecord]
      ]
    }) ;
    // const newData = update(records, {
    //   $splice: [
    //     [dragIndex, 1],
    //     [hoverIndex, 0, dragRecord]
    //   ]
    // }) ;
    console.log(`newData: ${newData}`);
    // setRecords(
    //   newData
    // );
    updateMyData(newData);
    console.log(newData)
    
  };

  // Render the UI for your table
  return (
    <DragAndDrop>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr 
            {...headerGroup.getHeaderGroupProps()}
            >
              <th/>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(
            (row, index) =>
              prepareRow(row) || (
                <Row
                  index={index}
                  row={row}
                  moveRow={moveRow}
                  {...row.getRowProps()}
                />
              )
          )}
        </tbody>
      </table>
    </DragAndDrop>
  );
}
